import { render, staticRenderFns } from "./index.vue?vue&type=template&id=896c5d1c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c5d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896c5d1c')) {
      api.createRecord('896c5d1c', component.options)
    } else {
      api.reload('896c5d1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=896c5d1c&scoped=true&", function () {
      api.rerender('896c5d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/finance/pondsSource/index.vue"
export default component.exports